(function($) {
    let scrolling = false, videos_youtube_Loaded = false, videosLoaded = false;
    let video = $('.video-wrapper');
    let video_youtube = $('.video-youtube');
    let videoArray = [];
    let video_youtube_Array = [];
   

    if(video.length > 0 ){
        for (var i=0; i < video.length; i++ ){ 
            videoArray.push($(video[i]).data("video-code"));
        }
    }
    if(video_youtube.length > 0 ){
        for (var i=0; i < video_youtube.length; i++ ){ 
            video_youtube_Array.push($(video_youtube[i]).data("src"));
        }
    }
    function doScrolling() {
        if (!videosLoaded && video.length && window.isInViewport(video)){
            if(videoArray.length > 0){
                videoArray.forEach(function(item){
                    
                    let video_wrapper = $('.video-wrapper[data-video-code="'+item+'"]');
                    let videoTitle = video_wrapper.data("video-title");
                    let html = '<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">'+
                                    '<div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">'+
                                        '<iframe src="https://fast.wistia.net/embed/iframe/'+item+'?videoFoam=true" title="'+ videoTitle +'" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="100%" height="100%"></iframe>'+
                                    '</div>'+
                                '</div>'+
                                '<script src="https://fast.wistia.net/assets/external/E-v1.js" async defer></script>';
            
                    video_wrapper.html(html);
                     
                });
            }
            videosLoaded= true;
        }
        if (!videos_youtube_Loaded && video_youtube.length > 0 && window.isInViewport(video_youtube)){
            if(video_youtube_Array.length > 0){
                video_youtube_Array.forEach(function(item){
                    let video_wrapper = $('.video-youtube[data-src="'+item+'"]');
                    let html = '<div class="video-wrapper">'+
                                    '<iframe allow="autoplay; encrypted-media" allowfullscreen="" frameborder="0" height="315" src="'+item+'" title="video" width="100%"></iframe>'+
                                '</div>';
                    video_wrapper.html(html);
                      
                });
            }  
            videos_youtube_Loaded= true;
        }
    }

    $(window).on('scroll resize', () => { scrolling = true; } );

    function scrollingTimer() {
        if (scrolling) doScrolling();
        window.setTimeout(scrollingTimer,250);
    }

    scrollingTimer();
    

})($);